// Bus mínimo para avisar que la sesión expiró, sin acoplar api.ts (módulo plano,
// sin contexto de React) a session.tsx (que ya importa api.ts — evita el ciclo).
const target = new EventTarget();
const EVENT = 'session-expired';

export function emitSessionExpired() {
  target.dispatchEvent(new Event(EVENT));
}

export function onSessionExpired(callback: () => void): () => void {
  target.addEventListener(EVENT, callback);
  return () => target.removeEventListener(EVENT, callback);
}
